export const restaurantViewReducer = (state = null, action) => {
    switch (action.type) {
        
        case 'restaurantView':
            return action.payload;

        default:
            return state
    }
}
export default restaurantViewReducer;